import { isPgCTLProduct } from "features/LearningItems/getProductDisplayConfig"
import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import { importantSearchParams } from "utils/constants"

import OfferLetterSheet from "../OfferLetterSheet"
import {
  PgCTLOfferLetterDialog,
  usePgCTLOfferLetter,
} from "../usePgCTLOfferLetter"
import Banner from "./Banner"

const OfferLetterBanner = () => {
  const { offerLetter } = usePgCTLOfferLetter()
  const [searchParams, setSearchParams] = useSearchParams()
  // Lets a caller (e.g. the mobile app, after auto-signing the user in) deep
  // link straight into the sheet via ?dialog=offer-letter-dialog instead of
  // landing on the banner and requiring a second click. The param is kept in
  // the URL (only cleared on close) so the deep link survives a remount of
  // this component, e.g. Home swapping its mobile/desktop layout branch.
  const [openSheet, setOpenSheet] = useState(
    searchParams.get(importantSearchParams.dialog) ===
      PgCTLOfferLetterDialog.OfferLetter
  )

  if (!offerLetter || !isPgCTLProduct(offerLetter.product.slug)) return null

  const openOfferLetter = () => {
    setOpenSheet(true)
  }

  const closeOfferLetter = () => {
    setOpenSheet(false)
    if (
      searchParams.get(importantSearchParams.dialog) ===
      PgCTLOfferLetterDialog.OfferLetter
    ) {
      setSearchParams(
        prev => {
          prev.delete(importantSearchParams.dialog)
          return prev
        },
        { replace: true }
      )
    }
  }

  return (
    <>
      <div className="flex flex-col">
        <Banner offerLetter={offerLetter} openOfferLetter={openOfferLetter} />
      </div>
      <OfferLetterSheet open={openSheet} handleClose={closeOfferLetter} />
    </>
  )
}

export default OfferLetterBanner
